// extracted by mini-css-extract-plugin
export default {"breadCrumbsWrapper":"breadCrumb_breadCrumbsWrapper__UVQLT","breadCrumb":"breadCrumb_breadCrumb__7fGYs","active":"breadCrumb_active__8S5dT"};